import { createVNode as _createVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-6bb0b9b8")

_pushScopeId("data-v-6bb0b9b8")
const _hoisted_1 = { class: "sold-out-feed" }
const _hoisted_2 = /*#__PURE__*/_createVNode("div", { class: "hint" }, "当商品存在下架或者删除时，可通过此Feed链接，将商品在Criteo同步下架", -1)
const _hoisted_3 = { class: "link-wrap" }
const _hoisted_4 = { class: "control" }
const _hoisted_5 = /*#__PURE__*/_createTextVNode("复制链接")
const _hoisted_6 = /*#__PURE__*/_createVNode("div", { class: "info" }, "默认同步近3000个同步下架/删除商品", -1)
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  const _component_FormSkeleton = _resolveComponent("FormSkeleton")
  const _component_el_button = _resolveComponent("el-button")

  return (_openBlock(), _createBlock("div", _hoisted_1, [
    _hoisted_2,
    _createVNode("div", _hoisted_3, [
      _createVNode(_component_FormSkeleton, {
        loading: _ctx.loading,
        type: "mini-text"
      }, {
        default: _withId(() => [
          _createTextVNode(_toDisplayString(_ctx.link), 1)
        ]),
        _: 1
      }, 8, ["loading"])
    ]),
    _createVNode("div", _hoisted_4, [
      _createVNode(_component_el_button, {
        size: "medium",
        onClick: _ctx.copyLink,
        disabled: _ctx.loading
      }, {
        default: _withId(() => [
          _hoisted_5
        ]),
        _: 1
      }, 8, ["onClick", "disabled"]),
      _hoisted_6
    ])
  ]))
})